<template>
    <div>
        <div class="spark-screen lg:container">
            <div class="rounded bg-white shadow-md spark-settings-tabs">
                <nav class="py-2 px-3 flex rounded-t justify-between align-items-center">
                    <div class="nav flex hidden md:inline">
                        <a class="mr-3 w-full md:w-auto text-grey-darkest" role="tab"
                           data-toggle="tab"
                           aria-controls="project-comments"> Contact Notes</a> <span
                        class="hidden md:inline"></span>
                    </div>
                    <button title="This tool utilizes all information within the Company and Contact pages. For more precise results, please add as much information as possible into all fields."
                            data-toggle="tooltip" data-placement="top"
                            type="button" class="btn btn-primary border-4 rounded-full tooltip-contact-research-ai-class" @click="openAIContactInfo" :disabled="researchAILoader">
                        <i v-if="researchAILoader" class="fa fa-spin fa-spinner text-white" aria-hidden="true"></i>
                        <span class="material-icons text-sm-custom text-white p-1 text-center">
                            auto_awesome
                        </span>
                        Research with AI
                    </button>
                </nav>
                <div class="tab-content justify-center">
                    <div role="tabcard" class="tab-pane active" id="project-comments">
                        <div class="py-2 px-3 border-b-2 border-followup-nav text-grey-darkest">
                            <form @submit.prevent="saved" @keydown="form.errors.clear($event.target.name)">
                                <div class="mb-2">
                                    <ckeditor-container
                                        id="notes"
                                        v-model="form.note"
                                        :options="allUsers"
                                        @mention="addMention"
                                        mentionFrom="name"
                                    ></ckeditor-container>
                                    <div class="text-red text-xs" v-if="form.errors.has('note')">{{
                                            form.errors.get('note')
                                        }}
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between">
                                    <button
                                        class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none bg-teal"
                                        :class="{'bg-teal-lighter cursor-not-allowed' : form.errors.any(), 'bg-teal' : !form.errors.any()}"
                                        :disabled="form.errors.any()"
                                        v-if="(!sharedCompanyObj.isSharedCompany || (sharedCompanyObj.access !== null && sharedCompanyObj.access !== 'view'))">
                                        <span>Save</span>
                                    </button>
                                </div>
                            </form>
                            <div class="float-right" style="margin-top: -32px;">
                                <div class="snippetPopOverContactNotes">
                                    <snippets-popover></snippets-popover>
                                </div>
                            </div>
                        </div>


                        <div class="spark-screen lg:container">
                            <div class="rounded bg-white shadow-md spark-settings-tabs">
                                <nav class="border-b-2 border-followup-nav py-2 px-3 flex bg-primary text-white">
                                    <div class="nav flex hidden md:inline">
                                        <a class="mr-3 w-full md:w-auto text-white active" href="#tab-notes" role="tab"
                                           data-toggle="tab"
                                           aria-controls="tab-notes">Notes</a> <span
                                        class="hidden md:inline">|</span>
                                        <a class="md:ml-3 w-full md:w-auto mr-3 text-white" href="#tab-activity-logs" role="tab"
                                           data-toggle="tab"
                                           aria-controls="tab-activity-logs"> Activity Logs</a>
                                    </div>
                                </nav>
                                <div class="tab-content justify-center">
                                    <div role="tabcard" class="tab-pane active" id="tab-notes">
                                        <div class="flex border-b-2 border-followup-nav text-grey-darkest rounded-t p-2 justify-between">
                                            <span class="pl-2">Notes</span>
                                        </div>
                                        <div v-if="notesList.length > 0" @click.stop="editNotes(notesListVal,idx)"
                                             v-for="(notesListVal, idx) in notesList"
                                             :id="'notes' + notesListVal.id" :key="idx" :name="'notes' + notesListVal.id"
                                             :class="notesListVal.pinned ? 'bg-orange-lightest hover:bg-orange-lighter' : 'hover:bg-grey-lighter'"
                                             class="comment-area px-3 flex-col text-grey-darkest border-b-1 py-3 cursor-pointer">
                                            <div class="flex flex-wrap flex-md-nowrap md:justify-between text-sm mb-2">
                                                <div class="flex flex-wrap flex-md-nowrap">
                                                    <div class="mr-3 w-full md:w-auto">{{ notesListVal.created_at  }}</div>
                                                    <div class="mx-3 w-full md:w-auto">
                                                        <span>General</span>
                                                    </div>
                                                    <div class="mx-3 w-full md:w-auto">
                                                        <div class="flex flex-wrap" v-if="notesListVal.openai_chat_completion_id">
                                                            <span class="material-icons text-sm-custom text-teal p-1 text-center">
                                                                auto_awesome
                                                            </span>
                                                            <span>AI Generated</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="w-full md:w-auto" v-if="notesListVal.creator">
                                                    <span>Created by: </span><span class="text-grey-darkest font-medium">{{ notesListVal.creator }}</span>
                                                </div>
                                            </div>

                                            <div class="flex justify-between">
                                                <div class="leading-tight md:mr-32 text-grey-darkest whitespace-pre-wrap ul-list-style-type"
                                                     v-html="notesListVal.note ? formatTextView(notesListVal) : ''">&ndash;&gt;
                                                </div>
                                                <div>
                                                    <button
                                                        @click.prevent.stop="deleteNotes(notesListVal, idx)" v-if="((canEdit  || assignedUserID == currentUserId || assignedUserID == 0) && (!sharedCompanyObj.isSharedCompany))"
                                                        class="focus:outline-none text-base font-light text-grey-darkest hover:text-grey-darkest material-icons hidden md:inline">
                                                        delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="notesList.length === 0" class="mb-2">
                                            <div class="px-3 py-2 text-grey-darkest text-sm" v-if="is_client">
                                                Your company does not currently have any notes.
                                            </div>

                                            <div class="px-3 py-2 text-grey-darkest text-sm" v-else>
                                                Your contact does not currently have any notes.
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabcard" class="tab-pane" id="tab-activity-logs">
                                        <contact-activity-logs :current-user-id="currentUserId" :contact="contact"></contact-activity-logs>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Form from "../../utils/form";
import CKEditorContainer from '../shared/ckeditor-container';
import Swal  from "sweetalert2";
import axios from "axios";
import SnippetsPopover from "../shared/snippets-popover.vue";
export default {
    name: "contact-notes",
    fetchApiUrl: 'api.contact.note.fetch',
    props: ['company', 'contact','is_client', 'canEdit', 'currentUserId', 'assignedUserID', 'sharedCompanyObj'],
    components: {SnippetsPopover, CKEditorContainer},
    data() {
        return {
            form: new Form({
                note: '',
                noteId: 0,
                contact: this.contact,
                mentioned_users: [],
                aiChatCompletionId: null
            }),
            notesList: [],
            user: null,
            allUsers: [],
            researchAILoader: false
        }
    },
    mounted() {
        if(this.is_client === "true"){
            this.fetchClientNotes();
        }else {
            // if(this.isLoadNoteList()) {
            //     console.log('here false')
                this.fetchContactNotes();
            // }
        }
        this.fetchTeamUsers();
        this.addToolTip();
    },
    watch: {
        'form.note': function(value) {
            if(value.trim() === "") {
                this.form.aiChatCompletionId = null;
            }
        }
    },
    methods: {
        fetchClientNotes(){

            axios.get(route('api.company.notes', {
                company: this.company.id,
            })).then(({data}) => {
                this.notesList = data.data;
            }).catch((error) => {

                console.log(error)

            });
        },
        fetchContactNotes() {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            axios.get(route('api.contact.note.fetch', {
                contactId: this.contact.id,
            })).then((companyCotactNotes) => {
                if (companyCotactNotes.data.status) {
                    this.notesList = companyCotactNotes.data.data;
                }
            }).catch((error) => {
                Toast.fire({
                    type: 'error',
                    title: "Error."
                });
            })
        },

        editNotes(noteObj, idx) {
            let text = noteObj.note;
            let emailId = noteObj.email_id;
            let emailTimestamp = noteObj.email_timestamp;

            if(emailId && emailTimestamp && !text.includes('Date:') && !text.includes('Date and Time:')) {
                text = 'Date: ' + this.externalEmailTimestampFormat(emailTimestamp) + '\r\n' + text;
            }

            this.form.note = text;
            this.form.noteId = noteObj.id;
            this.form.aiChatCompletionId = noteObj.openai_chat_completion_id;
        },
        deleteNotes(note, idx) {
            const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 2000
            });
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#01B1AF',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) {
                    if(this.is_client){
                axios.delete(route('api.note.destroy', {
                    company: this.company,
                    noteId: note.id,
                    contact:this.contact
                })).then((resp) => {
                    if (resp.data.status) {
                        Toast.fire({
                            type: 'success',
                            title: resp.data.message
                        });
                        window.location.reload();
                    } else {
                        Toast.fire({
                            type: 'error',
                            title: "Error."
                        });
                    }
                }).catch((error) => {
                    Toast.fire({
                        type: 'error',
                        title: "Error."
                    });
                })
            }else {
                axios.delete(route('api.contact.note.destroy', {
                    contactId: this.contact.id,
                    noteId: note.id,
                    contact:this.contact
                })).then((resp) => {
                    if (resp.data.status) {
                        Toast.fire({
                            type: 'success',
                            title: resp.data.message
                        });
                        window.location.reload();
                    } else {
                        Toast.fire({
                            type: 'error',
                            title: "Error."
                        });
                    }
                }).catch((error) => {
                    Toast.fire({
                        type: 'error',
                        title: "Error."
                    });
                })
            }
                }
            });
        },
        saved() {

            if(this.is_client){
                this.form.post(route('api.note.store', {
                    company: this.company
                })).then((resp) => {
                    if (resp.status) {

                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        Toast.fire({
                            type: 'success',
                            title: resp.message
                        });
                        window.location.reload();
                    } else {
                        Toast.fire({
                            type: 'error',
                            title: 'Failed'
                        });
                    }
                    this.form.reset();
                    this.fetchClientNotes();
                }).catch((error) => {
                    console.log('error', error);
                });

            }else {

                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });
                this.form.post(route('api.contact.note.store', {
                    contact: this.contact
                })).then((resp) => {
                    if (resp.status) {
                        Toast.fire({
                            type: 'success',
                            title: resp.message
                        });
                        window.location.reload();
                    } else {
                        Toast.fire({
                            type: 'error',
                            title: 'Failed'
                        });
                    }
                    this.form.reset();
                    window.location.reload();
                }).catch((error) => {
                    console.log('error', error);
                });
            }
        },
        formatTextView(note) {
            let text = note.note;
            let emailId = note.email_id;
            let emailTimestamp = note.email_timestamp;

            if(emailId && emailTimestamp && !text.includes('Date:') && !text.includes('Date and Time:')) {
                text = 'Date: ' + this.externalEmailTimestampFormat(emailTimestamp) + '\r\n' + text;
            }

            if (text.split('From:').length > 2) {
                return `From: ${text.split('From:')[1].trim()}`;
            }
            return text;
        },
        isLoadNoteList() {

            if(this.canEdit || this.assignedUserID == this.currentUserId || this.assignedUserID == 0) {

                return true;
            }
            else {

                return false;
            }
        },
        fetchTeamUsers() {
            axios.get(route('api.team-users')).then(({data}) => {
                this.allUsers = data.filter((m) => (m.pivot.active && m.is_registered));
            })
        },
        addMention(replaced) {
            if (_.find(this.form.mentioned_users, o => o === replaced.id)) {
                return;
            }
            this.form.mentioned_users.push(replaced.id);
        },
        externalEmailTimestampFormat(timestamp) {
            return moment(timestamp).format('L LT');
        },
        insertSnippet(data){
            this.form.note = this.form.note +''+ data;
        },
        openAIContactInfo() {
            let self = this;
            self.researchAILoader = true;

            axios.post(route('api.openai.contact-info', {contactId: self.contact.id})).then((response) => {
                self.form.aiChatCompletionId = response.data.chatCompletionId;
                self.form.note = response.data.content;
                self.researchAILoader = false;
            }).catch((error) => {
                self.researchAILoader = false;
            });
        },
        addToolTip() {
            setTimeout(() => {
                $(".tooltip-contact-research-ai-class").tooltip('dispose');
                $(".tooltip-contact-research-ai-class").tooltip();
            }, 2000);
        },
    }
}
</script>

<style scoped>
.text-sm-custom {
    font-size: .900rem;
}
</style>
